export default "<p>\n  Contact-us Component works!\n</p>\n"